// adapted from django-experiments to workaround non-appended slash bug
// see: https://github.com/mixcloud/django-experiments/issues/168

import fetchUser from './fetchUser';
import {once} from 'lodash';

const initialize = once(async () => {
    const user = await fetchUser();
    if (!user.isConfirmedHuman) {
        await fetch('/experiments/confirm_human/', {method: 'POST'});
    }
});

export default {
    async goal(name: string) {
        await initialize();
        await fetch('/experiments/goal/' + name + '/', {method: 'POST'});
    },
};

initialize();
